import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import useFiltro from 'hooks/useFiltro';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import Banderas from './Banderas';
import ClienteCard from './ClienteCard';

const Clientes = () => {
    const [customers, setCustomers] = useState([]);
    const [agrupacionPaises, setAgrupacionPaises] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [countries, setCountries] = useState([]);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const { FiltroCliente, setFiltroCliente, resetFiltroCliente } = useFiltro();

    // Estado para clientes seleccionados
    const [clientesSeleccionados, setClientesSeleccionados] = useState([]);

    // Estados para paginación
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize] = useState(20); // Número de elementos por página
    const [hasMoreData, setHasMoreData] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);


    const mostrarClientes = async (page = 1, append = false) => {
        if (!append) {
            setCargando(true);
        } else {
            setLoadingMore(true);
        }

        // Preparar objeto con filtros y paginación
        const filtrosConPaginacion = {
            ...FiltroCliente,
            pageNumber: page,
            pageSize: pageSize
        };

        const response = await fetch("/api/cliente/getclientesakasia/?vFiltro=" + encodeURIComponent(JSON.stringify(filtrosConPaginacion)),
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
        if (response.ok) {
            const data = await response.json();
            console.log("=============== MOSTRAR CLIENTES ===============");
            console.log(data['table1']);
            console.log(data['table2']);

            const nuevosClientes = data['table1'] || [];

            if (append) {
                setCustomers(prev => [...prev, ...nuevosClientes]);
            } else {
                setCustomers(nuevosClientes);
                setPageNumber(1);
                // Solo actualizar agrupación y países en la primera carga
                setAgrupacionPaises(data['table2']);
                console.log(data['table3']);
                setCountries(data['table3']);

            }

            // Verificar si hay más datos disponibles
            // Asumiendo que el endpoint devuelve el total en table4
            const totalRecordsFromResponse = data['table4']?.[0]?.totalRecords || 0;
            setTotalRecords(totalRecordsFromResponse);
            setHasMoreData((page * pageSize) < totalRecordsFromResponse);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            if (!append) {
                setCustomers([]);
                setHasMoreData(false);
            }
        }

        if (!append) {
            setCargando(false);
        } else {
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        mostrarClientes();
    }, []);

    /**
     * Función para cargar más datos (infinite scroll)
     */
    const cargarMasDatos = () => {
        if (hasMoreData && !loadingMore && !cargando) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            mostrarClientes(nextPage, true);
        }
    };

    /**
     * Componente para el trigger de infinite scroll
     */
    const InfiniteScrollTrigger = () => {
        const triggerRef = React.useRef();

        React.useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMoreData && !loadingMore && !cargando) {
                        cargarMasDatos();
                    }
                },
                { threshold: 0.1 }
            );

            if (triggerRef.current) {
                observer.observe(triggerRef.current);
            }

            return () => {
                if (triggerRef.current) {
                    observer.unobserve(triggerRef.current);
                }
            };
        }, [hasMoreData, loadingMore, cargando, pageNumber]);

        if (!hasMoreData) return null;

        return (
            <div ref={triggerRef} className="text-center py-4">
                {loadingMore ? (
                    <div>
                        <Spinner animation="border" variant="primary" className="mb-2" />
                        <div className="text-muted small">Cargando más clientes...</div>
                    </div>
                ) : (
                    <div className="text-muted small">Desplázate para cargar más</div>
                )}
            </div>
        );
    };

    /**
     * Función para alternar la selección de un cliente
     */
    const toggleSeleccionCliente = (idCliente) => {
        setClientesSeleccionados(prev => {
            if (prev.includes(idCliente)) {
                return prev.filter(id => id !== idCliente);
            } else {
                return [...prev, idCliente];
            }
        });
    };

    /**
     * Resetear filtros y recargar
     */
    const handleResetFiltros = () => {
        resetFiltroCliente();
        setPageNumber(1);
        setHasMoreData(true);
        setCustomers([]);
        mostrarClientes(1, false);
    };

    /**
     * Buscar con filtros y resetear paginación
     */
    const handleBuscar = () => {
        setPageNumber(1);
        setHasMoreData(true);
        setCustomers([]);
        mostrarClientes(1, false);
    };

    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/cliente96.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>
                            Catálogo de clientes
                        </h5>
                    </Col>
                    <Col sm="auto" className="ms-auto">
                        <Link to="/clientes/nuevo">
                            <Button size="sm"
                                variant="falcon-primary"
                            >Nuevo Cliente</Button>
                        </Link>
                    </Col>
                </Row>
            </Card>

            <Card className="mb-3">
                <Card.Header className="bg-light">
                    {/* Resumen por países */}
                    <Row className="g-3 mb-3">
                        {agrupacionPaises.map((pais, index) => {
                            return (
                                <Col key={index} xl xs={6} md={4} className="text-center">
                                    <SoftBadge pill bg="success" className="me-2 fs--2 mb-2">
                                        <FontAwesomeIcon icon="caret-up" className="me-1" />
                                        {pais.NumLicAct} Lic
                                    </SoftBadge>
                                    <br></br>
                                    <Banderas Height={38} vPais={pais.vPais}></Banderas>

                                    <h5 className="mb-1 font-sans-serif">
                                        <CountUp
                                            start={0}
                                            end={pais.Num}
                                            duration={2.75}
                                            className="text-700"
                                            separator=","
                                        />
                                    </h5>
                                    <span className="fw-normal fs--2 text-600">{pais.vPais}</span>
                                </Col>
                            )
                        })}
                    </Row>

                    <hr></hr>

                    {/* Filtros */}
                    <Form>
                        <Row className="flex-between-center g-2">
                            <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    value={FiltroCliente.vPais}
                                    onChange={(event) => { setFiltroCliente({ ...FiltroCliente, vPais: event.target.value }) }}
                                >
                                    <option value="">Todos los pa&iacute;ses</option>
                                    {countries.map((pais, index) => {
                                        return (<option key={index} value={pais.vName}>{pais.vName}</option>)
                                    })}
                                </Form.Select>
                            </Col>

                            <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    value={FiltroCliente.vEstatusCliente}
                                    onChange={(event) => { setFiltroCliente({ ...FiltroCliente, vEstatusCliente: event.target.value }) }}
                                >
                                    <option value="">Todos los estatus</option>
                                    <option value="prueba">Clientes Solo Licencias Prueba</option>
                                    <option value="activa">Clientes Solo Licencias Activas</option>
                                    <option value="nolicencia">Clientes Sin Licencias</option>
                                </Form.Select>
                            </Col>

                            <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                                <Form.Group className="col-12">
                                    <Form.Control
                                        onChange={(event) => { setFiltroCliente({ ...FiltroCliente, vSearch: event.target.value.toUpperCase() }) }}
                                        size="sm"
                                        type="text"
                                        placeholder="Cliente, Razón social, teléfono, correo"
                                        value={FiltroCliente.vSearch}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                                {cargando ? <Button
                                    variant="falcon-default"
                                    size="sm"
                                    transform="shrink-3"
                                    disabled
                                >
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />&nbsp;
                                    Buscando...
                                </Button>
                                    : <><IconButton
                                        variant="falcon-default"
                                        type="submit"
                                        size="sm"
                                        icon="search"
                                        transform="shrink-3"
                                        onClick={handleBuscar}
                                    >
                                        <span className="d-none d-sm-inline-block ms-1">Buscar</span>
                                    </IconButton> <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="redo-alt"
                                        transform="shrink-3"
                                        className="mx-2"
                                        onClick={handleResetFiltros}
                                    >
                                            <span className="d-none d-sm-inline-block ms-1">Reset</span>
                                        </IconButton></>}
                            </Col>
                        </Row>
                    </Form>
                </Card.Header>

                <Card.Body className="p-0">
                    {cargando ? (
                        <div className="p-4">
                            {[...Array(5)].map((_, index) => (
                                <Card key={index} className="mb-3">
                                    <Card.Body>
                                        <Row>
                                            <Col xs={12} md={2}>
                                                <Skeleton height={30} width={80} className="mb-2" />
                                                <Skeleton height={40} width={40} className="mb-2" />
                                                <Skeleton height={15} width={60} />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Skeleton height={20} className="mb-2" />
                                                <Skeleton height={15} width={200} />
                                                <Skeleton height={15} width={180} />
                                                <Skeleton height={15} width={150} />
                                            </Col>
                                            <Col xs={12} md={4} className="text-end">
                                                <Skeleton height={30} width={120} className="mb-2" />
                                                <Skeleton height={25} width={100} />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    ) : customers.length > 0 ? (
                        <div className="p-3">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <small className="text-muted">
                                    Mostrando {customers.length} de {totalRecords > 0 ? totalRecords : customers.length} clientes
                                </small>
                                {clientesSeleccionados.length > 0 && (
                                    <small className="text-primary fw-bold">
                                        {clientesSeleccionados.length} cliente{clientesSeleccionados.length !== 1 ? 's' : ''} seleccionado{clientesSeleccionados.length !== 1 ? 's' : ''}
                                    </small>
                                )}
                            </div>
                            {customers.map((cliente) => (
                                <ClienteCard
                                    key={cliente.idClienteAkasia}
                                    cliente={cliente}
                                    isSelected={clientesSeleccionados.includes(cliente.idClienteAkasia)}
                                    onToggleSelection={toggleSeleccionCliente}
                                />
                            ))}
                            <InfiniteScrollTrigger />
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <img src="/img/cliente96.png" alt="No hay clientes" height={60} className="opacity-50" />
                            </div>
                            <h5 className="text-muted">No se encontraron clientes</h5>
                            <p className="text-muted">
                                No hay clientes registrados con los filtros seleccionados
                            </p>
                            {customers.length === 0 && (
                                <Link to="/clientes/nuevo">
                                    <Button variant="primary">
                                        <FontAwesomeIcon icon={icon({ name: 'plus', style: "solid" })} className="me-1" />
                                        Registrar primer cliente
                                    </Button>
                                </Link>
                            )}
                        </div>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default Clientes;
